import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import HoneyfundLink from 'components/Registry/HoneyfundLink.tsx';
import WilliamsSonomaLink from 'components/Registry/WilliamsSonomaLink.tsx';

const textStyle = {
  fontFamily: '"Waterfall", serif',
  //fontWeight: 'bold',
  color: 'text.secondary',
  textAlign: 'center',
  
}

 export default function Registry() {
  return (
    <Box sx={{
      py: 3,
      px: {xs: 0, md: 3},
      alignSelf:"center",
      alignContent: "center",
      alignItems: "center",
      justifyContent: "center",
      display: 'flex',
    }}>
      <Card sx={{ 
          maxWidth: 800,
          width: "100%",
          backgroundColor: "#ffeedd",
          display: 'flex', 
          flexDirection: "column",
        }}>
        <CardHeader 
          title="Registry" 
          titleTypographyProps = {{variant: "h1", sx: textStyle}}
          />
        <CardContent 
          sx={{
            width: "100%", 
            px: 0,
          }}
        >
          <Typography 
            variant="body2" 
            component="div"
            sx={{ 
              color: 'text.secondary',
              alignSelf:"center",
              textAlign:"left",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              pt: "1rem",
              px: "1rem",
            }}
          >
            We are so fortunate to have all of you celebrating with us, and look forward making new memories together! 
            While your presence is the greatest present, here are a few ideas if you are so inclined. 
        
            <ul style={{paddingLeft: "1em", listStyleType:"none"}}>
              <li><WilliamsSonomaLink /></li>
              <li>We love using thoughtful gifts in our home everyday! Here are a few items that will remind us of you as we build our life together as a married couple. This registry includes physical items from Willaims Sonoma, West Elm and Pottery Barn</li>
            </ul>
            <ul style={{paddingLeft: "1em", listStyleType:"none"}}>
              <li><HoneyfundLink /></li>
              <li>We love experiences, and are hoping to make some very special memories with your help! This is a registry to contribute to our honeymooon fund.</li>
            </ul>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
